export const buttons = [
  {
    value: '',
    type: 'blank',
    key: '',
  },
  {
    value: '',
    type: 'blank',
    key: ''
  },
  {
    value: '',
    type: 'blank',
    key: ''
  },
  {
    value: 'C',
    type: 'operation',
    key: 'clear',
    keyCode: 46,
  },
  {
    value: '7',
    type: 'number',
    key: 'seven',
    keyCode: 103,
  },
  {
    value: '8',
    type: 'number',
    key: 'eight',
    keyCode: 104,
  },
  {
    value: '9',
    type: 'number',
    key: 'nine',
    keyCode: 105,
  },
  {
    value: '/',
    type: 'operation',
    key: 'divide',
    keyCode: 111,

  },
  {
    value: '4',
    type: 'number',
    key: 'four',
    keyCode: 100,
  },
  {
    value: '5',
    type: 'number',
    key: 'five',
    keyCode: 101,
  },
  {
    value: '6',
    type: 'number',
    key: 'six',
    keyCode: 102,
  },
  {
    value: 'x',
    type: 'operation',
    key: 'multiply',
    keyCode: 106,
  },
  {
    value: '1',
    type: 'number',
    key: 'one',
    keyCode: 97,
  },
  {
    value: '2',
    type: 'number',
    key: 'two',
    keyCode: 98,
  },
  {
    value: '3',
    type: 'number',
    key: 'three',
    keyCode: 99,
  },
  {
    value: '-',
    type: 'operation',
    key: 'subtract',
    keyCode: 109,
  },
  {
    value: '0',
    type: 'number',
    key: 'zero',
    keyCode: 96,
  },
  {
    value: '.',
    type: 'number',
    key: 'decimal',
    keyCode: 110,
  },
  {
    value: '=',
    type: 'operation',
    key: 'equals',
    keyCode: 13,
  },
  {
    value: '+',
    type: 'operation',
    key: 'add',
    keyCode: 107,
  },
]